import classNames from 'classnames';
import React from 'react';
import SVGIcon from '../../components/SVGIcon';
import pdfIcon from '../../icons/prefilled/16x16/pdf.svg';
import ignoreInChromatic from '../../utils/ignoreInChromatic';
import getExtname from '../../utils/url/getExtname';
import useSourceWithAssetToken from '../AssetTokenContext';
import EmbedFooter from '../embed/EmbedFooter';
import getReadableSize from '../utils/getReadableSize';
import * as styles from './File.module.scss';

interface FileProps {
  name: string;
  size: number;
  source: string;
  uploading: boolean;
}
const File = (props: FileProps) => {
  const { name, size, uploading } = props;
  const extension = getExtname(name);
  const source = useSourceWithAssetToken(props.source);

  if (extension === 'pdf') {
    return (
      <div
        className={classNames('file-container', styles.wrapper)}
        data-testid="fileContainer"
      >
        <div className={styles.container}>
          <div
            className={classNames(styles.fileContent, {
              [styles.uploading]: uploading,
            })}
          >
            <div className={styles.pdfFileContainer}>
              {!uploading && (
                <iframe
                  className={styles.pdfEmbed}
                  src={`${source}#toolbar=0&view=FitH`}
                  title={name}
                  {...ignoreInChromatic()}
                />
              )}
            </div>
          </div>
          <EmbedFooter
            icon={<SVGIcon>{pdfIcon}</SVGIcon>}
            title={name}
            action={<div className={styles.size}>{getReadableSize(size)}</div>}
            link={uploading ? undefined : source}
          />
        </div>
      </div>
    );
  }

  return null;
};

export default File;
